export enum CreditCardAssociation {
  visa,
  mastercard,
  americanExpress,
  discover,
}
